import { makeStyles } from '@material-ui/core/styles'
import { Box, Divider, Tooltip } from '@mui/material'
import GreyInfoIcon from 'src/assets/Buy_Policy_Images/GreyInfoIcon.svg'
import {
  viewPlanCovered,
  viewPlanNotCovered,
} from 'src/utils/constants/BuyPolicyMotor'

const Covered = () => {
  const classes = useStyles()

  return (
    <Box className={classes.coveredContainer}>
      <Box className={classes.covered}>
        <Box className={classes.coveredHeading}>What&apos;s covered</Box>
        <Box className={classes.descriptionText}>
          All insurance companies provide similar basic coverage for their
          policies.
        </Box>
        <Box className={classes.coveredList}>
          {viewPlanCovered?.map((item) => {
            return (
              <Box
                className={classes.listItem}
                key={`viewPlanCovered_${item?.id}`}
              >
                <Box>
                  <img src={item?.logo} className={classes.logo} />
                </Box>
                <Box className={classes.textSection}>
                  <Box className={classes.listText}>
                    {item?.text}{' '}
                    <Tooltip
                      arrow
                      title={
                        <>
                          <Box>{item?.toolTipText}</Box>
                        </>
                      }
                    >
                      <img src={GreyInfoIcon} className={classes.infoImage} />
                    </Tooltip>
                  </Box>
                </Box>
              </Box>
            )
          })}
        </Box>
      </Box>
      <Divider
        orientation='vertical'
        variant='fullWidth'
        flexItem
        className={classes.divider}
      />
      <Box className={classes.notCovered}>
        <Box className={classes.notCoveredHeading}>What&apos;s not covered</Box>
        <Box className={classes.descriptionText}>
          All insurance companies commonly have similar exclusions across
          policies.
        </Box>
        <Box className={classes.coveredList}>
          {viewPlanNotCovered?.map((item) => {
            return (
              <Box
                className={classes.listItem}
                key={`viewPlanNotCovered_${item?.logo}`}
              >
                <Box>
                  <img src={item?.logo} className={classes.logo} />
                </Box>
                <Box className={classes.textSection}>
                  <Box className={classes.listText}>
                    {item?.text}{' '}
                    <Tooltip
                      arrow
                      title={
                        <>
                          <Box>{item?.toolTipText}</Box>
                        </>
                      }
                    >
                      <img src={GreyInfoIcon} className={classes.infoImage} />
                    </Tooltip>
                  </Box>
                </Box>
              </Box>
            )
          })}
        </Box>
      </Box>
    </Box>
  )
}

export default Covered

const useStyles = makeStyles({
  coveredContainer: {
    display: 'flex',
    flexDirection: 'row',
    padding: '0px 30px',
  },
  coveredHeading: {
    fontFamily: 'Roboto',
    fontWeight: '500',
    fontSize: '18px',
    color: '#10A98F',
  },
  notCoveredHeading: {
    fontFamily: 'Roboto',
    fontWeight: '500',
    fontSize: '18px',
    color: '#E04F5F',
  },
  descriptionText: {
    fontFamily: 'Roboto',
    fontWeight: '400',
    fontSize: '13px',
    lineHeight: '16.5px',
    color: '#858585',
    padding: '10px 0px',
  },
  covered: {
    paddingTop: '20px',
    paddingRight: '30px',
  },
  notCovered: { paddingTop: '20px', paddingLeft: '20px' },
  coveredList: {
    display: 'flex',
    flexDirection: 'column',
    gap: 10,
    alignItems: 'left',
    padding: '10px 0px',
  },
  listText: {
    fontFamily: 'Roboto',
    fontWeight: '500',
    fontSize: '15px',
    lineHeight: '19.04px',
    color: '#323232',
    textAlign: 'left',
  },
  listItem: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
    marginRight: 'auto',
  },
  logo: {
    width: '30px',
    height: '40px',
    paddingRight: '30px',
  },
  infoImage: { marginBottom: '-5px !important' },
  textSection: {
    display: 'flex',
    flexDirection: 'row',
    borderBottom: '1px solid #E0E0E0',
    paddingBottom: '20px',
  },
  divider: { margin: 'unset' },
})
